import React from 'react';
import { TextRectangle, Label, TransparentTouchBox } from './components';
import { isMobilePhone, isMobileTablet } from '../../library/calc';

export default ({
    node,
    npu,
    pr_id,
    left,
    top,
    onClickedInvite,
    stopStageClickPropagation,
    cursorBecomesMove,
    cursorBecomesPointer,
    userTouchedNode,
    setNodeForFlipFocus,
    setShowMobileFlipCard,
    setFlipCardScreenIsOn,
    setCurZoomScaleWhenClicked,
    showToolTipFor,
    hideToolTip,
    nm,
    translatedLabels,
    isPedigree,
  }) => {

  const props = {
    node,
    npu,
    pr_id,
    left,
    top,
    onClickedInvite,
    stopStageClickPropagation,
    cursorBecomesMove,
    cursorBecomesPointer,
    userTouchedNode,
    setNodeForFlipFocus,
    setShowMobileFlipCard,
    setFlipCardScreenIsOn,
    setCurZoomScaleWhenClicked,
    showToolTipFor,
    hideToolTip,
    nm,
    translatedLabels,
    isPedigree,
  };

    let multipleParentComponents = [
        <TextRectangle key={Math.random()} {...props} />,
        <Label key={Math.random()} {...props} />,
    ];

    if(isMobilePhone() || isMobileTablet() ) {
        multipleParentComponents.push(
            <TransparentTouchBox key={Math.random()} {...props} />
        );
    }

  return multipleParentComponents;
};

